import $ from 'jquery';

import { getBusinessSearchUrl, getDefaultPageSize } from 'chairisher/context/search';

const facetNames = ['location', 'page_size', 'sort', 'specialization']; // facetNames for this search view
const searchFormSelector = '.js-business-search-form';
const eventNameSpace = 'businessSearch';

/**
 * Handles searching for businesses
 */
class BusinessSearchView {
    constructor() {
        this.$searchForm = $(searchFormSelector);
        this.facets = this.buildFacets();
    }

    /**
     * Build the facets which control input to this view.
     *
     * @return {jQuery}
     */
    buildFacets() {
        const facets = {};

        for (let i = 0; i < facetNames.length; i += 1) {
            facets[facetNames[i]] = $(`[name=${facetNames[i]}]`);
        }

        return facets;
    }

    /**
     * Construct a search object from the current state of the view.
     *
     * @return {Object.<string, string>}
     */
    buildSearch() {
        const search = {};

        $.each(this.facets, (field, $el) => {
            if (
                $el.val() &&
                // Special handling for page_size
                (field !== 'page_size' || parseInt($el.val(), 10) !== getDefaultPageSize())
            ) {
                search[field] = $el.val();
            }
        });

        return search;
    }

    /**
     * @param {string} eventName The name of the event to namespace
     * @returns {string} The namespaced event
     */
    nameSpacedEvent(eventName) {
        return [eventNameSpace, eventName].join('.');
    }

    /**
     * Trigger an event.
     *
     * @param {Event} event Base event which is cloned into the triggered event
     * @param {string} type Type of event to trigger
     * @param {Object=} data Optional data to pass along with the event
     */
    trigger(event, type, data) {
        const newEvent = $.extend({}, event); // clone so we don't modify the original event object
        const namespacedType = this.nameSpacedEvent(type);
        newEvent.type = namespacedType;
        const triggeredEvent = $.Event(namespacedType, newEvent);

        this.getSearchForm().trigger(triggeredEvent, data);
    }

    /**
     * Get the search form.
     *
     * @return {jQuery}
     */
    getSearchForm() {
        return this.$searchForm;
    }

    /**
     * Bind the search view.
     */
    bind() {
        const { $searchForm } = this;

        const submit = (e) => {
            e.preventDefault();
            const search = this.buildSearch();
            let url = getBusinessSearchUrl();
            const params = $.param(search);
            if (params) {
                url += `?${params}`;
            }
            this.trigger(e, 'submit', {
                url,
                search,
            });
        };

        $searchForm.on('submit', submit);
        this.facets.page_size.on('change', submit);
        this.facets.sort.on('change', submit);
    }
}

export default BusinessSearchView;
